'use strict'

const crypto = require('browserify-aes')

module.exports = {
  createCipheriv: crypto.createCipheriv,
  createDecipheriv: crypto.createDecipheriv
}



//////////////////
// WEBPACK FOOTER
// ./~/libp2p-crypto/src/crypto/ciphers-browser.js
// module id = 255
// module chunks = 0